import { Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { AddressGoogleDto, GeoCodeGoogleDto, ReverseGeoCodeGoogleDto} from '../../model/address-google-dto'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class GeocodingService {
  constructor(private http: HttpClient) {
  }

  autoCompleteGoogleSearch(searchText: string): Observable<AddressGoogleDto[]> {
    const sUrl = environment.baseUrl + '/geocode/autocomplete?search=' + searchText
    return this.http
      .get<AddressGoogleDto[]>(sUrl)
      .pipe(map((response) => response.map((response) => ({ id: response.place_id, ...response }))))
  }

  geoCodeGoogle(placeId: string): Observable<GeoCodeGoogleDto> {
    const sUrl = environment.baseUrl + '/geocode?place_id=' + placeId
    return this.http.get<GeoCodeGoogleDto>(sUrl)
  }

  reverseGeoCodeGoogle(lat: number, lng: number): Observable<ReverseGeoCodeGoogleDto> {
    const sUrl = environment.baseUrl + '/geocode/reverse?lat=' + lat + '&lng=' + lng
    return this.http.get<ReverseGeoCodeGoogleDto>(sUrl)
  }

}


